import { createContext, useContext, type ReactNode } from 'react';

const FilterBarLoadingContext = createContext(false);

export function FilterBarLoadingProvider({
    loading,
    children,
}: {
    loading: boolean;
    children: ReactNode;
}) {
    return (
        <FilterBarLoadingContext.Provider value={loading}>
            {children}
        </FilterBarLoadingContext.Provider>
    );
}

export function useFilterBarLoading(): boolean {
    return useContext(FilterBarLoadingContext);
}
